import './LayerPanel.css';

const SGETypeToggleButtonItems = ({ typeItems, setTypeItems, layerVisibility }) => {

  const toggleCheckedState = (typeName) => {
    const updatedTypeItems = typeItems.map(item => {
      if (item.type === typeName) {
        return { ...item, checked: !item.checked };
      }
      return item;
    });
    // Update the type item state
    setTypeItems(updatedTypeItems);
  }

  const handleToggleGene = (event) => {
    toggleCheckedState(event.target.id);
  }

  const handleToggleGeneFull = (event) => {
    toggleCheckedState(event.target.id);
  }

  const handleToggleVelocytoAmbiguous = (event) => {
    toggleCheckedState(event.target.id);
  }

  const handleToggleVelocytoSpliced = (event) => {
    toggleCheckedState(event.target.id);
  }

  const handleToggleVelocytoUnspliced = (event) => {
    toggleCheckedState(event.target.id);
  }

  return (
    <div className='layerPanelControlVertical'>
      <label>
        <input type="checkbox" disabled={!layerVisibility} id="Gene" checked={typeItems?.find(sge => sge.type === "Gene")?.checked} onChange={handleToggleGene} />
        Gene
      </label>
      <label>
        <input type="checkbox" disabled={!layerVisibility} id="GeneFull" checked={typeItems?.find(sge => sge.type === "GeneFull")?.checked} onChange={handleToggleGeneFull} />
        GeneFull
      </label>
      <label>
        <input type="checkbox" disabled={!layerVisibility} id="VelocytoAmbiguous" checked={typeItems?.find(sge => sge.type === "VelocytoAmbiguous")?.checked} onChange={handleToggleVelocytoAmbiguous} />
        VelocytoAmbiguous
      </label>
      <label>
        <input type="checkbox" disabled={!layerVisibility} id="VelocytoSpliced" checked={typeItems?.find(sge => sge.type === "VelocytoSpliced")?.checked} onChange={handleToggleVelocytoSpliced} />
        VelocytoSpliced
      </label>
      <label>
        <input type="checkbox" disabled={!layerVisibility} id="VelocytoUnspliced" checked={typeItems?.find(sge => sge.type === "VelocytoUnspliced")?.checked} onChange={handleToggleVelocytoUnspliced} />
        VelocytoUnspliced
      </label>
    </div>
  )
}

export default SGETypeToggleButtonItems;